import $http from '@/libs/axios'
import axios from 'axios'
import { SERVER_URL } from '@/constants/config'

export default class AuthApi {
  static async login(data: any) {
    return (await $http.post('auth/owner-login', data)).data
  }

  static async loginByCode(data: any) {
    return (await $http.post('auth/login-code', data)).data
  }

  static async loginFb(data: any, redirect = false) {
    return (await $http.post(redirect ? 'auth/login' : 'auth/add-pages', data)).data
  }

  static async sanctum() {
    const axiosIns = axios.create({
      baseURL: SERVER_URL,
      headers: {
        common: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          dashboard: true,
          Accept: 'application/json',
          locale: 'ar',
        },
      },
    })
    await axiosIns.get('/sanctum/csrf-cookie')
  }

  static async user() {
    return (await $http.get('user/profile')).data
  }

  static async referralList() {
    return (await $http.get('admin/referrals')).data
  }
}
